import Marquee from "react-fast-marquee";

const ITEMS = [
  "Prepared with Love",
  "Authentic Taste",
  "चव पुण्याची",
  "Home-Style Thalis",
  "Fresh Bhakri Daily",
  "आठवण घरची",
  "Slow-Cooked Rassa",
];

function Star() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" className="mx-6 shrink-0" fill="#7a1f1f">
      <path d="M12 2l2.2 6.9H21l-5.6 4 2.2 6.9L12 15.7 6.4 19.8l2.2-6.9L3 8.9h6.8z" />
    </svg>
  );
}

export default function BrandMarquee() {
  return (
    <div data-testid="brand-marquee" className="border-y border-[#7a1f1f]/20 bg-[#d97706] py-4">
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-2xl md:text-3xl font-semibold text-[#2b1414] whitespace-nowrap">
              {t}
            </span>
            <Star />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
